import { PublicProfileDirectory } from "@/components/profile/PublicProfileDirectory";
import { useLanguage } from "@/contexts/LanguageContext";
import { useNavigate } from "react-router-dom";

export default function BuyerConsultants() {
  const { language } = useLanguage();
  const lang = (language as "en" | "fr") || "en";
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <PublicProfileDirectory
        roles={["consultant", "broker", "partner"]}
        lang={lang}
        title={lang === "fr" ? "Annuaire des experts" : "Expert Directory"}
        onContact={(uid) => navigate(`/messages?to=${uid}`)}
        onViewFull={(uid) => navigate(`/profile/public/${uid}`)}
      />
    </div>
  );
}
